import { Container, Row, Col, Navbar } from "react-bootstrap";
import logo from '../assets/img/logo.png';
import { FaGithub } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { FaFacebook } from "react-icons/fa";
import { IoLogoWhatsapp } from "react-icons/io";
import { collection, getDocs, query } from "firebase/firestore";
import { db } from "../firebase";
import { RiLoginCircleFill } from "react-icons/ri";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

export const Footer = () => {
  const [myData, setMyData] = useState([]);

  async function fetchData() {
      try {
          const projectRef = collection(db, 'profile');
          const q = query(projectRef);
          const querySnap = await getDocs(q);
          let projects = [];
          querySnap.forEach((doc) => {
              projects.push({
                  id: doc.id,
                  data: doc.data()
              });
          });
          setMyData(projects);
        // console.log(projects);
      } catch (error) {
          console.log(error);
      }
  }

  useEffect(() => {
    fetchData();
  }, []);
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <Col size={12} sm={6} style={{textAlign:"center",marginTop:"20px"}}>
          <Navbar.Brand href="/"  className="navbar-logo">
            <img src={logo} alt="Logo" style={{width:"200px"}}/>
          </Navbar.Brand>
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end" style={{marginTop:"40px"}}>
            <div className="social-icon" style={{display:"flex",justifyContent:"center",alignItems:"center"}}>
            <a href={myData[0]?.data.githubLink} target="_blank"  
                style={{backgroundColor:"white",transition: 'background-color 0.3s '}}  
                onMouseEnter={(e) => { 
                  e.currentTarget.style.backgroundColor = 'black'; 
                  e.currentTarget.querySelector('svg').style.color = 'white';
                }}
                onMouseLeave={(e) => { 
                  e.currentTarget.style.backgroundColor = 'white'; 
                   e.currentTarget.querySelector('svg').style.color = 'black';
                 }}><FaGithub style={{ fontSize: '2rem', color: 'black' }} /></a>
                
                <a href={myData[0]?.data.linkedinLink} target="_blank"  
                style={{backgroundColor:"white",transition: 'background-color 0.3s ease-in-out'}}  
                onMouseEnter={(e) => { 
                  e.currentTarget.style.backgroundColor = 'black'; 
                  e.currentTarget.querySelector('svg').style.color = 'white';
                }}
                onMouseLeave={(e) => { 
                  e.currentTarget.style.backgroundColor = 'white'; 
                   e.currentTarget.querySelector('svg').style.color = 'black';
                 }}><FaLinkedin style={{ fontSize: '2rem', color: 'black' }} /></a>
                
                <a href={myData[0]?.data.facebookLink}target="_blank"  
                style={{backgroundColor:"white",transition: 'background-color 0.3s ease-in-out'}}  
                onMouseEnter={(e) => { 
                  e.currentTarget.style.backgroundColor = 'black'; 
                  e.currentTarget.querySelector('svg').style.color = 'white';
                }}
                onMouseLeave={(e) => { 
                  e.currentTarget.style.backgroundColor = 'white'; 
                   e.currentTarget.querySelector('svg').style.color = 'black';
                 }}><FaFacebook style={{ fontSize: '2rem', color: 'black' }} /></a>
                
                <a href={myData[0]?.data.whatsappNo} target="_blank"  
                style={{backgroundColor:"white",transition: 'background-color 0.3s ease-in-out'}}  
                onMouseEnter={(e) => { 
                  e.currentTarget.style.backgroundColor = 'black'; 
                  e.currentTarget.querySelector('svg').style.color = 'white';
                }}
                onMouseLeave={(e) => { 
                  e.currentTarget.style.backgroundColor = 'white'; 
                   e.currentTarget.querySelector('svg').style.color = 'black';
                 }}><IoLogoWhatsapp style={{ fontSize: '2rem', color: 'black' }} /></a>
                
                <Link to='/login'
                style={{backgroundColor:"white",transition: 'background-color 0.3s ease-in-out'}}  
                onMouseEnter={(e) => { 
                  e.currentTarget.style.backgroundColor = 'black'; 
                  e.currentTarget.querySelector('svg').style.color = 'white';
                }}
                onMouseLeave={(e) => { 
                  e.currentTarget.style.backgroundColor = 'white'; 
                   e.currentTarget.querySelector('svg').style.color = 'black';
                 }}><RiLoginCircleFill  style={{ fontSize: '2rem', color: 'black' }} /></Link>
              
              

            </div>
            <p style={{textAlign:"center",fontWeight:"800"}}>Copyright @{myData[0]?.data.copyrightYear}. All Rights Reserved</p>
          </Col>
        </Row>
      </Container>
    </footer>
  )
}
